function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M281.541 195.09H280.02V318.267H281.541V195.09Z",
  fill: "#CCCCCC"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M224.258 233.604H222.737V352.589H224.258V233.604Z",
  fill: "#CCCCCC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M547.081 92.9688C535.143 92.9688 525.516 102.641 524.977 114.62C524.977 115.754 524.033 116.139 523.494 115.754C520.952 113.831 517.891 112.793 514.502 112.774C506.473 112.793 499.811 119.158 499.272 127.253C499.175 129.156 497.905 130.118 495.459 129.464C493.669 129.003 491.763 128.733 489.741 128.733C477.591 128.791 467.636 138.809 467.636 151.269C467.636 163.729 477.476 173.709 489.741 173.766C490.261 173.747 490.8 173.747 491.32 173.728L574.942 173.593C575.578 173.632 576.098 173.612 576.733 173.651C590.789 173.612 602.111 162.018 602.111 147.712C602.111 133.406 590.693 121.83 576.733 121.83C575.578 121.888 574.403 121.946 573.248 122.08C570.283 122.484 568.8 120.927 569.127 118.331C569.224 117.408 569.339 116.562 569.339 115.601C569.339 106.39 563.832 98.3911 556.015 94.93C553.204 93.6417 550.239 92.988 547.081 92.9688Z",
  fill: "#E6E6E6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M400.919 87.5462L367.898 80.0664C367.898 80.0664 362.333 81.797 368.283 86.3925C374.232 90.7958 382.107 95.6029 382.107 95.6029L400.919 87.5462Z",
  fill: "#6DB1D9"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M300.526 126.849L260.592 130.291C260.592 130.291 222.006 143.328 214.708 148.308C214.323 148.693 213.745 149.077 213.36 149.462C212.783 150.039 212.205 150.616 211.435 151.192C205.678 157.134 201.268 166.921 201.076 168.248C200.883 169.978 197.822 183.977 195.896 187.034C195.704 187.226 195.704 187.419 195.511 187.611C193.008 190.86 183.804 197.571 181.494 205.436C181.301 206.012 181.109 206.589 181.109 207.166C179.761 214.838 184.555 221.741 184.555 221.741C184.555 221.741 212.975 240.143 223.527 240.72C226.03 240.912 228.706 240.912 231.787 240.527C241.395 239.374 255.008 234.778 282.658 219.818C319.126 200.071 323.939 176.881 326.231 170.171C327.579 165.96 328.349 157.518 331.025 149.846C323.343 138.156 312.598 129.33 305.494 124.35L300.526 126.849Z",
  fill: "#CFCFCB"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M415.129 47.4746C415.322 55.339 415.514 78.5284 414.166 82.7394C412.626 87.9118 405.328 90.4115 405.328 90.4115C405.328 90.4115 267.889 159.614 251.176 167.863C224.874 169.594 215.863 155.019 213.36 149.462C213.745 149.077 214.323 148.693 214.708 148.308C222.005 143.136 260.592 130.291 260.592 130.291L300.526 126.849L405.906 84.4892C405.906 84.4892 409.353 81.6049 409.16 78.3553C408.968 75.1057 412.241 49.0321 412.241 49.0321L415.129 47.4746Z",
  fill: "#2878BE"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M194.568 239.181C188.811 239.566 185.922 238.412 185.73 238.22C184.575 237.835 184.189 236.489 184.575 235.528C184.96 234.566 186.308 233.989 187.27 234.374C187.463 234.374 194.375 237.066 209.721 231.124C210.876 230.74 212.032 231.317 212.417 232.278C212.802 233.432 212.224 234.585 211.261 234.97C204.349 238.027 198.784 238.989 194.568 239.181Z",
  fill: "#003748"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M184.767 222.125C184.767 222.125 213.187 240.526 223.738 241.103C226.241 241.296 228.918 241.296 231.999 240.911C230.651 238.604 229.11 235.739 226.819 231.893C203.791 225.567 187.848 213.299 181.128 207.55C179.973 215.222 184.767 222.125 184.767 222.125Z",
  fill: "#AAA99E"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M441.431 59.3575C441.624 63.9531 440.853 67.6065 439.698 67.7988C438.543 67.7988 437.195 64.1646 437.002 59.7421C436.617 55.1465 438.158 51.4931 438.735 51.3009C439.12 51.1278 441.046 54.762 441.431 59.3575Z",
  fill: "#003053"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M437.195 76.2402C437.195 71.6446 438.158 67.9912 439.313 67.9912C440.661 67.9912 441.623 71.6254 441.623 76.2402C441.623 80.855 440.083 84.4891 439.505 84.4891C438.928 84.4699 437.195 80.8357 437.195 76.2402Z",
  fill: "#003053"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M448.536 67.6067C444.127 68.9527 440.276 69.1449 439.891 67.9912C439.506 66.8375 442.779 64.7417 446.996 63.2034C451.405 61.8574 455.256 62.242 455.641 62.8188C456.026 63.3957 452.753 66.0684 448.536 67.6067Z",
  fill: "#003053"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M431.053 67.6065C435.462 66.4528 439.313 66.4528 439.698 67.6065C440.083 68.7602 436.617 70.683 432.208 72.0098C427.799 73.1635 423.755 72.5866 423.563 72.0098C423.389 71.4329 426.643 68.7602 431.053 67.6065Z",
  fill: "#003053"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M434.519 86.3921C426.258 83.8925 424.737 78.9123 424.737 78.9123L424.93 57.8188C424.93 57.8188 435.866 47.6663 444.127 49.9544C452.387 52.2618 456.218 58.9725 454.871 66.0485C453.523 72.9515 448.921 86.3729 435.674 86.3729C435.289 86.5844 434.904 86.5844 434.519 86.3921ZM415.129 47.474L413.781 48.2431L413.396 83.7002L408.024 87.9112L322.592 129.31C322.592 129.31 258.281 159.787 242.358 171.478C226.607 183.168 228.34 207.511 228.34 207.511C228.34 207.511 221.62 214.799 219.117 226.298C217.962 230.893 219.31 234.931 221.428 237.988C222.198 239.142 223.161 240.296 223.931 241.065C234.483 241.642 246.767 239.911 283.062 220.164C319.53 200.416 324.344 177.227 326.635 170.516C328.946 163.805 329.523 146.942 338.534 139.078C347.565 131.213 407.061 101.313 412.434 99.3905C417.998 97.4677 421.464 94.2181 421.464 94.2181L422.619 86.9305L424.93 86.7382C424.93 86.7382 428.203 92.4875 434.538 92.1029C443.183 91.3338 449.518 86.546 453.35 80.2198C459.492 70.4518 459.684 56.8382 453.927 49.7429C444.512 38.0521 424.564 50.3198 424.564 50.3198L424.179 43.0322L415.129 47.474Z",
  fill: "#E6E6E6"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M418.961 90.988C418.961 90.988 332.392 133.733 329.504 139.674C326.423 145.616 323.747 177.823 309.537 191.821C295.327 205.82 256.163 231.701 228.533 237.258C226.8 237.643 225.452 237.643 224.316 237.45C222.968 237.45 222.198 237.45 221.428 237.835C222.198 238.989 223.161 240.142 223.931 240.911C234.483 241.488 246.767 239.758 283.062 220.01C319.53 200.263 324.344 177.073 326.635 170.363C328.946 163.652 329.523 146.789 338.534 138.924C347.565 131.06 407.062 101.16 412.434 99.237C417.998 97.3141 421.464 94.0645 421.464 94.0645L422.619 86.777L425.315 88.3153C425.315 88.3153 430.109 91.5649 434.538 91.7571C443.183 92.1417 449.518 86.2001 453.35 79.874H453.157C453.157 79.874 441.643 92.1417 433.96 88.8921C426.278 85.8156 420.521 79.874 420.521 79.874L418.961 90.988Z",
  fill: "#B3B3B3"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M283.447 144.481L263.865 154.634L243.32 137.77C243.32 137.77 248.885 122.618 262.71 119.753C276.342 116.869 294.961 120.715 294.961 120.715C294.961 120.715 304.184 123.791 310.519 135.29C290.34 137.963 283.447 144.481 283.447 144.481Z",
  fill: "#003053"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M310.307 135.078L263.846 154.633C263.846 154.633 264.423 144.481 268.448 138.732C273.627 131.444 286.489 130.29 294.749 130.098C303.029 129.906 310.307 135.078 310.307 135.078Z",
  fill: "#315E87"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M262.132 125.887L259.051 78.7203L264.616 77.9512L267.697 125.118C267.697 125.311 265.771 127.426 262.132 125.887Z",
  fill: "#002732"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M283.254 67.0297L407.273 22.5545C407.273 22.5545 407.081 19.6703 404.019 17.3821C400.938 15.267 396.914 13.9402 394.604 15.0747C392.293 16.2284 279.038 63.3763 279.038 63.3763L283.254 67.0297Z",
  fill: "#4A94BE"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M249.463 63.0108L156.54 1.07629C156.54 1.07629 154.807 0.114875 150.975 2.03771C147.144 3.96054 142.33 7.5947 143.1 9.13297C143.87 10.6712 244.456 66.4527 244.456 66.4527L249.463 63.0108Z",
  fill: "#4A94BE"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M238.719 85.8154L100.297 138.54C100.297 138.54 97.7942 140.655 100.297 143.52C102.8 146.404 109.886 153.48 109.886 153.48C109.886 153.48 113.525 154.634 116.221 153.095C118.724 151.557 244.456 92.6992 244.456 92.6992L238.719 85.8154Z",
  fill: "#4A94BE"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M281.522 86.9697L276.535 91.5653C276.535 91.5653 413.223 168.632 416.862 168.632C420.501 168.825 437.214 162.114 438.947 160.576C440.488 159.23 439.14 157.499 439.14 157.499L281.522 86.9697Z",
  fill: "#4A94BE"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M283.062 85.2391C283.062 85.2391 269.622 81.4126 273.839 76.7978C278.248 72.2023 282.099 70.0871 286.894 68.7412C291.688 67.3952 284.198 62.9919 282.099 62.0305C279.981 61.2613 278.075 62.2228 273.646 65.8569C269.237 69.4911 263.48 71.7985 260.977 69.2988C258.474 66.7991 252.139 60.6653 249.27 61.4344C246.382 62.2035 239.296 66.6068 243.128 68.7219C246.96 70.837 256.76 73.8944 254.257 77.3555C251.754 80.7973 234.675 82.9125 234.29 84.8353C233.712 86.9504 242.743 92.5074 242.743 92.5074C242.743 92.5074 244.476 93.6611 247.73 91.9305C250.984 90.0077 255.027 82.5279 259.822 83.297C264.423 84.0662 273.646 93.2573 273.646 93.2573C273.646 93.2573 275.379 94.411 277.286 93.065C279.211 91.5267 284.968 87.7003 284.776 86.5466C284.776 85.8159 283.062 85.2391 283.062 85.2391Z",
  fill: "#003053"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M265.771 76.048C265.964 78.1631 264.423 79.8745 262.325 80.0667C260.592 80.259 259.071 79.1053 258.493 77.5671C258.493 77.3748 258.3 76.9902 258.3 76.6056C258.108 74.4905 259.648 72.7792 261.747 72.5869C263.865 72.3946 265.579 74.1252 265.771 76.048Z",
  fill: "#4A94BE"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M257.53 276.753C251.003 277.137 247.364 275.791 247.171 275.791C246.016 275.407 245.631 274.253 246.016 273.099C246.401 271.946 247.556 271.561 248.712 271.946C248.904 271.946 262.729 276.926 288.453 261.601C315.14 245.699 346.044 224.606 346.429 224.413C347.391 223.836 348.739 224.029 349.317 224.99C349.895 225.952 349.702 227.298 348.739 227.874C348.354 228.067 317.451 249.16 290.571 265.254C275.957 273.696 264.828 276.176 257.53 276.753Z",
  fill: "#003748"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M284.968 266.024C283.813 266.024 282.85 265.255 282.85 264.101C280.154 237.451 258.859 228.452 258.666 228.259C257.511 227.875 257.126 226.529 257.511 225.567C257.896 224.414 259.244 224.029 260.207 224.414C261.169 224.798 284.005 234.374 286.894 263.716C287.086 264.87 286.316 265.832 284.968 266.024C285.161 266.024 285.161 266.024 284.968 266.024Z",
  fill: "#003748"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M336.031 235.739C335.068 235.739 334.106 235.162 333.913 234.2C327.771 206.589 309.537 197.782 309.344 197.782C308.382 197.205 307.804 196.051 308.382 195.09C308.767 194.129 310.114 193.552 311.077 194.129C311.847 194.513 331.237 203.724 337.957 233.431C338.149 234.585 337.572 235.739 336.416 235.931C336.224 235.739 336.031 235.739 336.031 235.739Z",
  fill: "#003748"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M245.804 169.785C236.389 176.881 227.378 186.072 228.918 206.588C222.198 204.281 214.708 200.455 208.181 196.628C203.194 193.552 198.573 190.494 195.511 187.995C195.704 187.802 195.896 187.61 195.896 187.418C197.629 184.341 200.691 170.17 200.883 168.632C201.076 167.286 205.485 157.518 211.242 151.576C214.516 156.941 224.316 172.285 245.804 169.785Z",
  fill: "#97C4D7"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M311.462 169.594C300.718 175.151 289.57 182.246 278.441 188.764C276.708 189.726 275.167 190.687 273.454 191.649C268.852 194.148 264.423 196.436 260.014 198.552C249.655 203.339 239.854 206.608 231.036 206.608C231.036 206.608 230.073 182.457 247.344 173.632C254.257 167.69 294.191 150.442 304.935 145.635C306.668 144.866 307.631 144.481 307.631 144.481C307.631 144.481 315.313 152.154 311.462 169.594Z",
  fill: "#97C4D7"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M311.462 169.594C300.718 175.151 289.57 182.246 278.441 188.764C284.198 166.152 298.6 151.192 304.935 145.635C306.668 144.866 307.631 144.481 307.631 144.481C307.631 144.481 315.313 152.154 311.462 169.594Z",
  fill: "#659CB0"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M245.804 169.786C236.389 176.881 227.377 186.073 228.918 206.589C222.198 204.282 214.708 200.455 208.181 196.629C218.751 180.323 245.804 169.786 245.804 169.786Z",
  fill: "#C7DEF4"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M273.646 190.495C273.646 190.495 273.646 190.879 273.261 191.648C268.659 194.148 264.231 196.436 259.821 198.551C258.474 182.073 265.386 164.613 265.386 164.613L273.646 190.495Z",
  fill: "#659CB0"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M264.443 163.268L270.007 193.552L275.379 190.879L270.007 161.345L264.443 163.268Z",
  fill: "white"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M213.187 151.961C213.187 151.961 204.734 161.536 202.25 171.9C199.747 182.053 196.493 188.956 196.493 188.956L195.723 187.802C195.723 187.802 200.902 167.862 202.058 165.19C203.213 162.498 209.548 152.345 213.379 149.461C214.13 150.999 213.187 151.961 213.187 151.961Z",
  fill: "white"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M448.151 100.775L415.707 94.4492C415.707 94.4492 400.534 100.006 399.398 100.391C399.398 100.391 415.341 108.64 429.724 107.678C443.915 106.717 448.151 100.775 448.151 100.775Z",
  fill: "#6DB1D9"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M36.6222 12.8828C44.5744 12.8828 50.9669 19.3051 51.3135 27.2656C51.3135 28.0155 51.9489 28.2847 52.2955 28.0155C53.9899 26.7272 56.0116 26.0542 58.2644 26.035C63.5979 26.0542 68.0265 30.2845 68.3923 35.6684C68.4694 36.9182 69.2973 37.572 70.9147 37.1298C72.1085 36.8221 73.3793 36.6298 74.7078 36.649C82.7948 36.6875 89.3991 43.3597 89.3991 51.6279C89.3991 59.9153 82.8525 66.5491 74.7078 66.5876C74.3613 66.5876 73.9954 66.5683 73.6488 66.5683L18.0608 66.4914C17.6372 66.5107 17.2906 66.5107 16.867 66.5299C7.52855 66.5107 0 58.8001 0 49.2821C0 39.764 7.58631 32.0727 16.867 32.0727C17.6372 32.1112 18.4074 32.1496 19.1776 32.2265C21.1416 32.4957 22.1235 31.4574 21.9117 29.7268C21.8347 29.1115 21.777 28.5539 21.777 27.9001C21.777 21.7663 25.4353 16.4593 30.6341 14.1711C32.5403 13.3443 34.5235 12.902 36.6222 12.8828Z",
  fill: "#E6E6E6"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M280.231 453.442L221.563 419.639L279.943 386.124L338.611 419.927L280.231 453.442Z",
  fill: "#809BEE"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M280.52 386.681L221.852 420.484V353.166L280.52 319.382V386.681Z",
  fill: "#7491EB"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M280.52 453.711L221.852 419.927V352.608L280.52 386.412V453.711Z",
  fill: "#2356CD"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M280.231 386.681L221.563 352.897L279.943 319.382L338.611 353.166L280.231 386.681Z",
  fill: "#7491EB"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M339.17 420.197L280.52 454V386.682L339.17 352.897V420.197Z",
  fill: "#4D75E3"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M330.39 405.064L288.896 429.465C288.222 429.849 287.683 429.542 287.683 428.772V399.526C287.683 398.757 288.222 397.796 288.896 397.411L330.39 373.01C331.063 372.626 331.603 372.933 331.603 373.703V402.949C331.603 403.737 331.044 404.679 330.39 405.064ZM290.109 425.946L329.177 402.968V376.529L290.109 399.507V425.946Z",
  fill: "white"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M309.652 407.467C309.383 407.621 309.113 407.679 308.902 407.602L288.164 400.333C287.644 400.16 287.567 399.314 287.972 398.468C288.395 397.622 289.146 397.065 289.666 397.257L309.652 404.256L329.639 373.741C330.159 372.952 330.91 372.606 331.333 372.952C331.757 373.318 331.66 374.26 331.141 375.048L310.403 406.698C310.172 407.063 309.903 407.313 309.652 407.467Z",
  fill: "white"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M288.896 429.464C288.55 429.656 288.222 429.695 287.972 429.503C287.548 429.156 287.606 428.233 288.107 427.426L303.299 403.487C303.799 402.679 304.569 402.314 304.993 402.66C305.417 403.006 305.359 403.929 304.858 404.736L289.666 428.676C289.455 429.041 289.185 429.31 288.896 429.464Z",
  fill: "white"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M330.39 405.064C330.12 405.217 329.831 405.275 329.619 405.179L314.428 399.103C313.927 398.891 313.85 398.045 314.293 397.199C314.716 396.353 315.487 395.834 315.987 396.026L331.179 402.102C331.68 402.314 331.757 403.16 331.314 404.006C331.064 404.506 330.736 404.871 330.39 405.064Z",
  fill: "white"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M280.771 266.389H279.25V385.374H280.771V266.389Z",
  fill: "#CCCCCC"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M338.438 230.163H336.917V353.34H338.438V230.163Z",
  fill: "#CCCCCC"
});

const SvgEmailSentBackgroundImage = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 603,
  height: 454,
  viewBox: "0 0 603 454",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmailSentBackgroundImage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/email-sent-background-image.31167c1c.svg";
export { ForwardRef as ReactComponent };